module.exports = __webpack_public_path__ + "img/blz.0ddb45f0.svg";